<template>
    <div class="nav">
        <div class="box-big">
            <div class="top-title">
                <p class="title">研发阶段产品</p>
                <div class="border"></div>
            </div>
            <div class="text">
                <div class="product" :class="{disabled:item.disabled}" v-for="item in productList">
                    <div class="product-img">
                        <img class="image" :src="item.img" alt="">
                    </div>
                    <div class="product-content">
                        <template v-if="item.disabled">
                            <span class="product-options-shelves">{{item.name}}</span>
                        </template>
                        <template v-else>
                            <span class="product-title">{{item.name}}</span>
                            <span class="product-options">{{item.text}}</span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import img1 from "../../assets/demonstration/logo1.png"
    import img2 from "../../assets/demonstration/logo2.png"
    import img3 from "../../assets/demonstration/logo3.png"
    import img4 from "../../assets/demonstration/logo4.png"
    import img5 from "../../assets/demonstration/logo5.png"
    import img6 from "../../assets/demonstration/logo6.png"

    export default {
        name: "research-app.vue",
        data() {
            return {
                productList: [
                    {name: '兆播', text: "分布式存储网络", img: img1},
                    {name: '兆通', text: "数据价值融通服务平台", img: img2},
                    {name: '兆案', text: "容数据存证平台", img: img5},
                    {name: '兆装', text: "装备保障实验平台", img: img4},
                    {name: '兆保', text: "数据价值融通服务平台", img: img2},
                    {name: 'MT大屏', text: "数据存证平台", img: img1}
                ],

            }
        }
    }
</script>

<style scoped lang="scss">
    .nav {
        background-color: #fff;
        padding: 0px 50px 51px;
        /*padding-bottom: 51px;*/

        .box-big {
            width: 80%;
            margin-left: 10%;

        }

        .top-title {
            padding-top: 82px;

            .title {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #282F3C;
                margin-left: 96px;
            }

            .border {
                width: 27px;
                height: 3px;
                margin-top: 3px;
                background-color: #056DFF;
                margin-left: 85px;
            }
        }

        .text {
            display: flex;
            flex-wrap: wrap;
            min-width: 1340px;
            margin-left: 70px;
            /*margin-left: 100px;*/
            .product {
                width: 385px;
                height: 150px;
                background: #FAFBFC;
                border-radius: 5px;
                cursor: pointer;
                margin: 20px 30px;

                .product-img {
                    width: 115px;
                    height: 115px;
                    background: #41D1C2;
                    border-radius: 50%;
                    margin: 17px 0px 18px 22px;

                    .image {
                        position: relative;
                        top: 35%;
                        left: 25%;
                        width: 54px;
                        height: 40px;
                    }
                }
            }

            .disabled {
                cursor: no-drop;
            }


            .product-content {
                display: flex;
                flex-wrap: wrap;
                margin-left: 33px;
                margin-top: -30px;
                position: relative;

                .product-options-shelves {
                    width: 158px;
                    height: 33px;
                    font-size: 24px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #999999;
                    line-height: 33px;
                    position: absolute;
                    bottom: 30px;
                    left: 150px;
                }


                .product-title {
                    width: 105px;
                    height: 33px;
                    font-size: 24px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #2A67E3;
                    line-height: 33px;
                    text-decoration: none;
                    position: absolute;
                    bottom: 58px;
                    left: 50%;
                }

                .product-options {
                    width: 126px;
                    height: 30px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    line-height: 20px;
                    text-decoration: none;
                    position: absolute;
                    bottom: 18px;
                    left: 50%;
                }
            }
        }
    }
</style>
